var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_81967",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300781,
    y: 0.80249,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_81967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3008 20.8025V4.80249C17.8508 4.80249 18.3216 4.99832 18.7133 5.38999C19.1049 5.78166 19.3008 6.25249 19.3008 6.80249V18.8025C19.3008 19.3525 19.1049 19.8233 18.7133 20.215C18.3216 20.6067 17.8508 20.8025 17.3008 20.8025ZM4.30078 22.8025C3.75078 22.8025 3.27995 22.6067 2.88828 22.215C2.49661 21.8233 2.30078 21.3525 2.30078 20.8025V4.80249C2.30078 4.25249 2.49661 3.78166 2.88828 3.38999C3.27995 2.99832 3.75078 2.80249 4.30078 2.80249H13.3008C13.8508 2.80249 14.3216 2.99832 14.7133 3.38999C15.1049 3.78166 15.3008 4.25249 15.3008 4.80249V20.8025C15.3008 21.3525 15.1049 21.8233 14.7133 22.215C14.3216 22.6067 13.8508 22.8025 13.3008 22.8025H4.30078ZM21.3008 18.8025V6.80249C21.7174 6.80249 22.0716 6.94832 22.3633 7.23999C22.6549 7.53166 22.8008 7.88582 22.8008 8.30249V17.3025C22.8008 17.7192 22.6549 18.0733 22.3633 18.365C22.0716 18.6567 21.7174 18.8025 21.3008 18.8025ZM4.30078 20.8025H13.3008V4.80249H4.30078V20.8025Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brandIcon.76f1e1603bcd957feec8b2f36cdeb7d7.svg";
export { ForwardRef as ReactComponent };